import { Component, Inject } from '@angular/core';
import { Participant } from '../../../interfaces/participant';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Approval, ApprovalColumn, ApprovalColumnLabels, ApprovalStatus } from '../../../interfaces/approval';
import { CommonModule } from '@angular/common';
import { ParticipantService } from '../../../services/participant.service';
import { NotifyService } from '../../../common/notify/notify.service';
import { AuthService } from '../../../auth/auth.service';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'approve-request-dialog-dialog',
  imports: [MatDialogModule, MatFormFieldModule, CommonModule, ReactiveFormsModule, FormsModule, MatOptionModule, MatSelectModule, MatInputModule, MatButtonModule],
  providers: [NotifyService],
  templateUrl: './approve-request-dialog.component.html',
  styleUrl: './approve-request-dialog.component.scss'
})
export class ApproveRequestDialogComponent {
  approvalComment: string = '';

  constructor(
    private readonly authService: AuthService,
    private readonly participantService: ParticipantService,
    private readonly ref: MatDialogRef<ApproveRequestDialogComponent>,
    private readonly notify: NotifyService,
    @Inject(MAT_DIALOG_DATA) readonly approval: Approval
  ) {}
  //Used for when an error occurs, it won't show that the approval is approved
  approvalCopy: Approval | null = null;

  async close() {
    this.approvalCopy = {
      ...this.approval,
      status: ApprovalStatus.APPROVED,
      approvalReason: this.approvalComment.trim() || undefined
    };
    this.participantService.updateApproval(this.approvalCopy).subscribe({
      next: () => {
        this.approval.status = ApprovalStatus.APPROVED;
        this.approval.approvalReason = this.approvalComment.trim() || undefined;
        this.approval.dateProcessed = new Date().toISOString();
        this.notify.withAutodismiss(`Approved request for recipient ${this.approvalCopy?.recipient?.firstName} ${this.approvalCopy?.recipient?.lastName}`);
        this.ref.close(true);
      },
      error: (err) => {
        console.log(err);
        this.notify.withAutodismiss('Failed to approve request. Please try again.');
      }
    });
  }

  cancel() {
    this.ref.close(false);
  }
}
